"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var avataaars_1 = __importDefault(require("@gamepark/avataaars"));
var usePlayer_1 = __importDefault(require("../Hooks/usePlayer"));
var ChatSpeechBubble_1 = __importDefault(require("./ChatSpeechBubble"));
var SpeechBubble_1 = __importDefault(require("./SpeechBubble"));
function Avatar(_a) {
    var playerId = _a.playerId, speechBubbleProps = _a.speechBubbleProps, props = __rest(_a, ["playerId", "speechBubbleProps"]);
    var player = (0, usePlayer_1.default)(playerId);
    var query = new URLSearchParams(window.location.search);
    var gameId = query.get('game');
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ css: style }, props, { children: [(0, jsx_runtime_1.jsx)(avataaars_1.default, __assign({ circle: true }, player === null || player === void 0 ? void 0 : player.avatar, { css: avatarCss })), (speechBubbleProps === null || speechBubbleProps === void 0 ? void 0 : speechBubbleProps.children) ?
                (0, jsx_runtime_1.jsx)(SpeechBubble_1.default, __assign({}, speechBubbleProps, { children: speechBubbleProps.children })) :
                gameId && player && (0, jsx_runtime_1.jsx)(ChatSpeechBubble_1.default, __assign({ gameId: gameId, player: player }, speechBubbleProps))] })));
}
exports.default = Avatar;
var style = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 50%;\n  box-shadow: 0 0 0.4em black;\n"], ["\n  border-radius: 50%;\n  box-shadow: 0 0 0.4em black;\n"])));
var avatarCss = (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  left: -6%;\n  width: 112%;\n  height: 117%;\n"], ["\n  position: absolute;\n  bottom: 0;\n  left: -6%;\n  width: 112%;\n  height: 117%;\n"])));
var templateObject_1, templateObject_2;
